import { apiService, sessionService } from "@/_services";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import { userPool } from "@/_helpers/cognitoConfig";
import Vue from "vue";
import axios from "axios";

const user = JSON.parse(localStorage.getItem("user"));

const state = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null };

const actions = {
  async login({ dispatch, commit }, ctx) {
    if (this.source === "cognito") {
      commit("loginRequest");

      return new Promise((resolve, reject) => {
        const user = new CognitoUser({
          Username: ctx.username,
          Pool: userPool
        });

        const authDetails = new AuthenticationDetails({
          Username: ctx.username,
          Password: ctx.password
        });

        user.authenticateUser(authDetails, {
          onSuccess: session => {
            const idToken = session.getIdToken().getJwtToken();
            const refreshToken = session.getRefreshToken().getToken();

            commit("loginSuccess", { access: idToken, refresh: refreshToken, provider: "cognito" });
            dispatch("alert/success", "Success", { root: true });
            sessionService.onLoginSuccess(idToken);

            resolve({ access: idToken, refresh: refreshToken });
          },
          onFailure: err => {
            commit("loginFailure");
            dispatch("alert/error", err.message, { root: true });
            reject(err);
          }
        });
      });
    } else {
      commit("loginRequest");
      return axios
        .post(`${process.env.VUE_APP_GATEWAY_URL}auth/login`, {
          username: ctx.username,
          password: ctx.password,
        })
        .then(
          response => {
            const data = response.data;
            commit("loginSuccess", { ...data, provider: "local" });
            dispatch("alert/success", "Success", { root: true });
            sessionService.onLoginSuccess(data.access);
            return data;
          },
          error => {
            let message;
            let type;

            if (error.response?.status === 401) {
              type = "auth";
              message = error.response.data?.detail || "Incorrect username or password.";
            } else if (error.request) {
              type = "network";
              message = "We couldn't reach the login service. Please try again.";
            } else {
              type = "unknown";
              message = "An unexpected error occurred. Please try again.";
            }
            commit("loginFailure", message);
            dispatch("alert/error", message, { root: true });
            const loginError = new Error(message);
            loginError.type = type;
            loginError.original = error;
            throw loginError;
          }
        );
    }
  },

  /**
   * Login with Google
   */
  async googleLogin({ commit, dispatch }, response) {
    try {
      const googleIdToken = response;
      commit("loginSuccess", { access: googleIdToken, refresh: null, provider: "google" });
      dispatch("alert/success", "Login with Google successful", { root: true });
      sessionService.onLoginSuccess(googleIdToken);
    } catch (error) {
      console.error("Error en Google Login:", error);
      dispatch("alert/error", "Error logging in with Google", { root: true });
    }
  },
  async microsoftLogin({ commit, dispatch }, idToken) {
    try {
      commit("loginSuccess", { access: idToken, refresh: null, provider: "microsoft" });
      dispatch("alert/success", "Login with Microsoft successful", {
        root: true
      });
      sessionService.onLoginSuccess(idToken);
    } catch (error) {
      commit("loginFailure");
      dispatch("alert/error", "Error logging in with Microsoft", {
        root: true
      });
      throw error;
    }
  },
  /**
   * Logout
   * @param {*} param0
   */

  logout({ commit }) {
    sessionService.onLogout();
    apiService.logout();
    commit("logout");
  },

  /**
   * Adding new user
   * @param {} param0
   * @param {*} user
   */
  async register({ dispatch, commit }, user) {
    commit("registerRequest", user);
    await apiService.register(user).then(
      user => {
        if (
          user.message === "User registered. Verify your email to continue."
        ) {
          commit("registerSuccess", user);
          dispatch(
            "alert/success",
            "Account created. We will contact you to activate your account",
            {
              root: true
            }
          );
        } else {
          let message = "";
          if (user !== undefined) {
            Object.keys(user).forEach(function(key) {
              if (key === "email" || key === "username") {
                message += " " + user[key];
              }
            });
          }
          if (user.data !== undefined) {
            Object.keys(user).forEach(function(key) {
              if (key === "data") {
                Object.keys(user[key]).forEach(function(keyy) {
                  message += " " + user[key][keyy];
                });
              }
            });
          }
          /**/
          dispatch("alert/error", message, { root: true });
        }
        //router.push('/login');
      },
      error => {
        commit("registerFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  }
};
const mutations = {
  loginRequest(state) {
    state.status = { loggingIn: true };
    state.user = null;
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true };
    Vue.set(state, "user", user);
    localStorage.setItem("token", user.access);
    // Google/Microsoft logins have no refresh token — avoid storing the
    // literal strings "null"/"undefined", which localStorage would otherwise
    // treat as a truthy value on the next read.
    if (user.refresh) {
      localStorage.setItem("refresh", user.refresh);
    } else {
      localStorage.removeItem("refresh");
    }
    if (user.provider) {
      localStorage.setItem("auth_provider", user.provider);
    } else {
      localStorage.removeItem("auth_provider");
    }
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.user = null;
    state.status = {};
    localStorage.removeItem("token");
    localStorage.removeItem("refresh");
    localStorage.removeItem("auth_provider");
  },
  registerRequest(state) {
    state.status = { registering: true };
  },
  registerSuccess(state) {
    state.status = {};
  },
  registerFailure(state) {
    state.status = {};
  }
};

export const authentication = {
  namespaced: true,
  state,
  user,
  actions,
  mutations
};
